import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { AutofocusDirective } from './autofocus.directive';
import { ButtonComponent } from './button/button.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { FileProgressComponent } from './file-upload/file-progress.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { FileUploadDirective } from './file-upload/file-upload.directive';
import { FocusIndexDirective } from './focus-index.directive';
import { IconComponent } from './icon.component';
import { InputComponent } from './input/input.component';
import { LanguageSelectorComponent } from './language-selector/language-selector.component';
import { LinkComponent } from './link/link.component';
import { PaginatorComponent } from './paginator/paginator.component';
import { PasswordStrengthComponent } from './password-strength/password-strength.component';
import { SelectComponent } from './select/select.component';
import { ValidationErrorComponent } from './validation-error/validation-error.component';

const exportedComponents = [
  AutofocusDirective,
  FocusIndexDirective,
  ButtonComponent,
  DatePickerComponent,
  FileUploadComponent,
  FileProgressComponent,
  IconComponent,
  InputComponent,
  LinkComponent,
  CheckboxComponent,
  PaginatorComponent,
  PasswordStrengthComponent,
  SelectComponent,
  LanguageSelectorComponent,
  ValidationErrorComponent
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule
  ],
  declarations: [
    ...exportedComponents,
    FileUploadDirective,
  ],
  exports: [...exportedComponents]
})
export class ControlsModule { }
